export const PROCESS_ASSIGNMENT = 'processAssignment'
export const VIEW_ASSIGNMENT = 'viewAssignment'
export const DOWNLOAD_SOURCE = 'downloadSource'
export const ARCHIVE_ASSIGNMENT = 'archiveAssignment'
export const UNARCHIVE_ASSIGNMENT = 'unarchiveAssignment'
export const VIEW_REPORT = 'viewReport'
export const DOWNLOAD_REPORT = 'downloadReport'
export const DOWNLOAD_LABELS = 'downloadLabels'
export const DOWNLOAD_DOCUMENTS = 'downloadDocuments'
export const VIEW_SHIPMENTS = 'viewShipments'

export const STATUS_MANAGEMENT = 'statusManagement'
export const INTEGRATION_ASSIGNMENT = 'integrationAssignment'
export const ASSIGNMENT_HISTORY = 'assignmentHistory'
export const SYNC_TRACKING = 'syncTracking'
export const REOPTIMIZE = 'reoptimize'
export const RECREATE_LABELS = 'recreateLabels'

export const INTEGRATION_ITEM = 'integrationItem'
export const ITEM_HISTORY = 'itemHistory'
export const RECREATE_LABEL = 'recreateLabel'
